import { Alert, Card } from 'antd';
import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { customerApiKeysApi } from '../../../api/customerApiKeysApi';
import { useShopSessionStore } from '../../../hooks/shop/useShopSessionStore';
import { useI18n } from '../../../hooks/useI18n';
import { messages } from '../../../messages';
import { CustomerApiKeys } from '../../customerApiKeys/customerApiKeys';
import styles from './settings.module.scss';
import { routes } from '../routes';

export function Settings() {
  const { t } = useI18n();
  const { session } = useShopSessionStore();
  const history = useHistory();

  return (
    <div className={styles.page}>
      {session.canManageCustomerApi ? (
        <Card title={t(messages.customer.customerApi)}>
          <CustomerApiKeys
            resourceKey={session.customerId}
            issueApiKey={customerApiKeysApi.issueApiKey}
            getApiKeys={customerApiKeysApi.getApiKeys}
            revokeApiKey={customerApiKeysApi.revokeApiKey}
            reactivateApiKey={customerApiKeysApi.reactivateApiKey}
            onSelectApiKey={(apiKeyId) =>
              history.push(
                generatePath(routes.customerApiKeyLogs, { apiKeyId }),
              )
            }
          />
        </Card>
      ) : (
        <Alert
          type="info"
          showIcon={true}
          message={t(messages.customer.apiAccessRequired)}
        />
      )}
    </div>
  );
}
